export class Point {
    public X: number;
    public Y: number;

    public static NULL: Point = new Point(5000, 5000);

    public static build_from_array(coord: number[]): Point {
        return Point.build(coord[0], coord[1]);
    }
    public static build(x: number, y: number): Point {
        if(!Number.isNaN(x)) {
            if(!Number.isNaN(y)) {
                if (typeof (x) === typeof (1)) {
                    if (typeof (y) === typeof (1)) {
                        return new Point(x, y);
                    }
                }
            }
        }
        return null;
    }
    public static copy(rhs:Point): Point {
        return new Point(rhs.X, rhs.Y);
    }
    private constructor(x: number, y: number) {
        this.X = x;
        this.Y = y;
    }
    public toString(): string {

        return JSON.stringify(this.as_array);
    }
    public toArray(): number[] { // awh todo: remove me. use as_array instead. note that as_array is a getter attribute, not a method
        return this.as_array;
    }
    public get as_array(): number[] {
        return [this.X, this.Y];
    }
    public get as_json(): number[] {
        return this.as_array;
    }
    public toJSON() {  // awh todo: remove me. use as_json instead. note that as_json is a getter attribute, not a method
        return this.as_array;
    }
    public equals(rhs:Point):boolean{
        if (rhs.X==this.X){
            if(rhs.Y==this.Y){
                return true;
            }
        }
        return false;
    }
}

